var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.SurchargeCapping = YouLi.Trip.SurchargeCapping ? YouLi.Trip.SurchargeCapping : {};

(function (YouLi) {
    (function (Trip) {
        (function (SurchargeCapping) {
            YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled = false;
            YouLi.Trip.SurchargeCapping.SurchargePercent = 0;
            YouLi.Trip.SurchargeCapping.CallbackForModalConfirm = function () {
            };
            YouLi.Trip.SurchargeCapping.CountryStateSurchargeCapsList = {};

            let $countrySelectionModal = $('#SurchargeCappingCountryModal'),
                countrySelectionModalName = '#SurchargeCappingCountryModal';

            function initSurchargeCappingCountryDialog() {
                if (!YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled) {
                    return false;
                }

                $countrySelectionModal = $('#SurchargeCappingCountryModal');

                const countryIsSelected = $countrySelectionModal.find('#CountrySurchargeCap').val() !== '';
                const stateIsVisible = $countrySelectionModal.find('#StateSurchargeCap').closest('.form-group').is(':visible');
                const stateIsSelected = $countrySelectionModal.find('#StateSurchargeCap').val() !== '';

                const canContinue = countryIsSelected && (!stateIsVisible || stateIsSelected);

                $countrySelectionModal.find('.btn-surcharge-capping-confirm').prop('disabled', !canContinue);
                $countrySelectionModal.find('.surcharge-capping-payment-details').toggleClass('hidden', !canContinue);
                // do maths here
                $countrySelectionModal.find('.deposit-amount').text(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.AmountDue));
                let surchargePercentCap = getSelectedSurchargePercentCap();
                let finalSurchargePercent = YouLi.Trip.SurchargeCapping.SurchargePercent;

                if (surchargePercentCap > YouLi.Trip.SurchargeCapping.SurchargePercent) {
                    finalSurchargePercent = YouLi.Trip.SurchargeCapping.SurchargePercent;
                } else {
                    finalSurchargePercent = surchargePercentCap;
                }

                // this is a setup of the percentage we will use in the current transaction, to allow usage of payment form functions
                // we only need the default in this case to be setup to be able to use existing functions
                YouLi.PaymentChargeForm.Default.SurchargePercent = finalSurchargePercent;

                $countrySelectionModal.find('.surcharge-capping-percent').text(`${YouLi.PaymentChargeForm.GetSurchargePercent()}%`);
                $countrySelectionModal.find('.surcharge-capping-total-amount').text(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetSurchargeAmount())}`);

                const surchargeAmount = YouLi.PaymentChargeForm.GetSurchargeAmount();
                YouLi.PaymentChargeForm.UpdatePaymentInfo({
                    surchargeAmount: surchargeAmount
                });
                const totalAmountDueWithSurcharge = YouLi.PaymentChargeForm.GetChargeAmount();
                $countrySelectionModal.find('.total-amount-due-with-surcharge-capping').text(YouLi.PaymentChargeForm.GetFormattedCurrency(totalAmountDueWithSurcharge));

                $("#ChargeAmount").val(totalAmountDueWithSurcharge);
                $("input[Name=SurchargeAmount]").val(surchargeAmount);
            }

            function getSelectedSurchargePercentCap() {
                const selectedCountryCode = $countrySelectionModal.find('#CountrySurchargeCap').val();
                const selectedStateCode = $countrySelectionModal.find('#StateSurchargeCap').val();

                const country = (YouLi.Trip.SurchargeCapping.CountryStateSurchargeCapsList || []).find(function (x) {
                    return x.CountryCode === selectedCountryCode;
                });

                if (!country) {
                    return 0;
                }

                if (selectedStateCode !== '') {
                    const state = (country.States || []).find(function (x) {
                        return x.StateCode === selectedStateCode;
                    });

                    if (state) {
                        return state.SurchargeCapPercentage;
                    }
                }

                return country.SurchargeCapPercentage;
            }

            function updateBillingCountryAndState() {
                const $countryCappingElement = $countrySelectionModal.find('#CountrySurchargeCap');
                const $billingCountryElement = $('#p-billto-country');
                const $stateCappingElement = $countrySelectionModal.find('#StateSurchargeCap');
                const $billingStateElement = $('#p-billto-state');

                if ($billingCountryElement.length > 0) {
                    $billingCountryElement.val('');
                    $billingCountryElement.prop('disabled', false);

                    if ($countryCappingElement.length > 0 && $countryCappingElement.val() !== '') {
                        $billingCountryElement.val($countryCappingElement.val())
                        $billingCountryElement.prop('disabled', true);
                    }
                }

                if ($billingStateElement.length > 0) {
                    $billingStateElement.val('');
                    $billingStateElement.prop('disabled', false);

                    if ($stateCappingElement.length > 0 && $stateCappingElement.val() !== '') {
                        $billingStateElement.val($stateCappingElement.find('option:selected').text()).prop('disabled', true);
                    }
                }
            }

            YouLi.Trip.SurchargeCapping.Init = function () {
                if (!YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled) {
                    return false;
                }

                $(document)
                    .off('change', '.surcharge-capping-payment-method-selection input[name="PaymentMethod"]')
                    .on('change', '.surcharge-capping-payment-method-selection input[name="PaymentMethod"]', function (e) {
                        YouLi.CreditCardPaymentForm.PaymentGatewaySpecificMethod = $(this).val();
                        const surchargePercent = parseFloat($(this).data('surcharge-percent'));
                        YouLi.Trip.SurchargeCapping.SurchargePercent = Number.isNaN(surchargePercent) ? 0 : surchargePercent;

                        const selectedMethodText = $(this).siblings('.payment-method-label')
                            .first()
                            .contents()
                            .filter(function () {
                                return this.nodeType === Node.TEXT_NODE;
                            })
                            .text()
                            .trim();
                        $('#SurchargeCappingCountryModal').find('.payment-method-selected').text(selectedMethodText);

                        let helperText = '* No surcharge applies.';

                        if (YouLi.Trip.SurchargeCapping.SurchargePercent > 0) {
                            helperText = `* A surcharge may apply when paying by ${selectedMethodText}. You will be asked to confirm your billing location.`;
                        } else {
                            // for those 0 surcharges, we need to clear billing country, states selected and don't disable
                            $('#CountrySurchargeCap').val('').trigger('change');
                            updateBillingCountryAndState();
                        }

                        $(this).closest('.surcharge-capping-payment-method-selection').find('.surcharge-capping-helper-text').text(helperText);
                    });

                $(document)
                    .off('shown.bs.modal', countrySelectionModalName)
                    .on('shown.bs.modal', countrySelectionModalName, function () {
                        $('#CountrySurchargeCap').val('US').trigger('change');
                        initSurchargeCappingCountryDialog();
                    })
                    .off('hidden.bs.modal', countrySelectionModalName)
                    .on('hidden.bs.modal', countrySelectionModalName, function () {
                        $('#StateSurchargeCap').val('');
                        $('#CountrySurchargeCap').val('');
                    })
                    .off('click', `${countrySelectionModalName} .btn-surcharge-capping-confirm`)
                    .on('click', `${countrySelectionModalName} .btn-surcharge-capping-confirm`, function (e) {
                        e.preventDefault();
                        updateBillingCountryAndState();
                        YouLi.Trip.SurchargeCapping.CallbackForModalConfirm();
                        $countrySelectionModal.modal('hide');
                    })
                    .off('change', `${countrySelectionModalName} #CountrySurchargeCap`)
                    .on('change', `${countrySelectionModalName} #CountrySurchargeCap`, function (e) {
                        const selectedCountryCode = $(this).val();
                        const country = (YouLi.Trip.SurchargeCapping.CountryStateSurchargeCapsList || []).find(function (x) {
                            return x.CountryCode === selectedCountryCode;
                        });

                        const states = country ? country.States || [] : [];
                        const $stateSelect = $('#StateSurchargeCap');
                        const $stateGroup = $stateSelect.closest('.form-group');

                        $stateSelect.empty().append($('<option>', {value: '', text: 'Select a state'}));

                        states.forEach(function (state) {
                            $stateSelect.append($('<option>', {value: state.StateCode, text: state.StateName}));
                        });

                        $stateSelect.val('');
                        $stateGroup.toggleClass('hidden', states.length === 0);

                        initSurchargeCappingCountryDialog();
                    })
                    .off('change', `${countrySelectionModalName} #StateSurchargeCap`)
                    .on('change', `${countrySelectionModalName} #StateSurchargeCap`, function (e) {
                        initSurchargeCappingCountryDialog();
                    });

                // in used for checkout-flow required trigger
                $('input[name="PaymentMethod"]:checked').trigger('change');
            }

            $(function () {
                YouLi.Trip.SurchargeCapping.Init();
            });


        }(YouLi.Trip.SurchargeCapping ? YouLi.Trip.SurchargeCapping : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));